import { call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { actions as toastrActions } from 'react-redux-toastr';
import api from 'services/api';
import { authAPI } from 'services/apiRest';
import { profilesAPI } from 'services/apiRest';

import AuthActions from '../ducks/auth';
import ConvocationsActions from '../ducks/convocations';
import ProfilesActions from '../ducks/profiles';
import ModulesActions from '../ducks/modules';
import { MODULES, saveCurrentModuleToStorage } from '../../config/modules';

// const uuidv1 = require('uuid/v1');

// getAuthChannel removido - agora usamos APIs REST
// A verificação de autenticação é feita via token JWT

export function* loginStatusWatcher() {
  try {
    // Verificar se há token salvo (primeiro localStorage, depois sessionStorage)
    let token = localStorage.getItem('authToken');
    if (!token) {
      token = sessionStorage.getItem('authToken');
    }
    
    if (token) {
      try {
        // Verificar token e buscar usuário
        const usuario = yield call(authAPI.verify);
        
        // Log para debug
        console.log('🔍 [auth saga] Usuário recebido do backend:', {
          id: usuario.id,
          email: usuario.email,
          profile_id: usuario.profile_id,
          profile_id_type: typeof usuario.profile_id,
        });
        
        // Converter formato para compatibilidade
        const userActive = {
          ...usuario,
          id: usuario.id,
          uid: usuario.id,
        };

        // Log para debug
        console.log('🔍 [auth saga] userActive formatado:', {
          id: userActive.id,
          email: userActive.email,
          profile_id: userActive.profile_id,
        });

        // SEMPRE permitir login se tiver profile_id (não usar mais role ou profile - campos descontinuados)
        if (userActive && userActive.profile_id) {
          yield put(AuthActions.signInSuccess(userActive));
          // Carregar permissões do usuário
          yield put(ProfilesActions.getMyPermissionsRequest());
          yield put(ConvocationsActions.getConvocationsRequest());
        } else {
          console.warn('⚠️ [auth saga] Usuário sem profile_id:', userActive);
          authAPI.logout();
          yield put(AuthActions.signOut());
          yield put(push('/signin'));
        }
      } catch (error) {
        // Token inválido ou expirado
        console.log('Token inválido, fazendo logout');
        authAPI.logout();
        yield put(AuthActions.signOut());
      }
    } else {
      console.log('User not logged');
    }
    
    yield put(AuthActions.authCheckedSuccess());
  } catch (error) {
    console.error('Error in loginStatusWatcher:', error);
    yield put(AuthActions.authCheckedSuccess());
  }
}

export function* signIn({ email, password, rememberMe = false }) {
  try {
    console.log('🚀 Iniciando processo de login...');
    // Usar API REST ao invés de Firebase
    const resultado = yield call(authAPI.login, email, password, rememberMe);
    
    console.log('📦 Resultado do login recebido:', resultado);
    
    // Verificar se o token foi salvo (localStorage ou sessionStorage)
    let token = localStorage.getItem('authToken');
    if (!token) {
      token = sessionStorage.getItem('authToken');
    }
    if (!token) {
      throw new Error('Token não foi salvo após o login. Tente novamente.');
    }
    const storageType = localStorage.getItem('authToken') ? 'localStorage' : 'sessionStorage';
    console.log(`✅ Token verificado no ${storageType} após login`);
    
    if (!resultado || !resultado.usuario) {
      throw new Error('Resposta inválida do servidor. Usuário não encontrado na resposta.');
    }
    
    // Converter formato para compatibilidade com o frontend
    const user = {
      ...resultado.usuario,
      id: resultado.usuario.id,
      uid: resultado.usuario.id, // Para compatibilidade
    };

    console.log('✅ Usuário formatado:', user);
    console.log('🔍 [auth saga] user.profile_id após login:', {
      id: user.id,
      email: user.email,
      profile_id: user.profile_id,
      profile_id_type: typeof user.profile_id,
    });
    
    yield put(AuthActions.signInSuccess(user));
    // Carregar permissões do usuário após login
    yield put(ProfilesActions.getMyPermissionsRequest());
    
    // Aguardar permissões carregarem para redirecionar corretamente
    const permissions = yield call(profilesAPI.buscarMinhasPermissoes);
    yield put(ProfilesActions.getMyPermissionsSuccess(permissions));
    
    // Redirecionar baseado em permissões de módulo
    const hasTransporte = permissions.modules?.includes('transporte') || false;
    const hasFinanceiro = permissions.modules?.includes('financeiro') || false;
    
    if (hasTransporte) {
      yield put(ModulesActions.setModuleSuccess(MODULES.TRANSPORTE));
      saveCurrentModuleToStorage('transporte');
      yield put(push('/dashboard'));
    } else if (hasFinanceiro) {
      yield put(ModulesActions.setModuleSuccess(MODULES.FINANCEIRO));
      saveCurrentModuleToStorage('financeiro');
      yield put(push('/financeiro/dashboard'));
    } else {
      // Se não tem acesso a nenhum módulo, tentar dashboard padrão
      yield put(push('/dashboard'));
    }
  } catch (error) {
    console.error('❌ Erro no login:', error);
    console.error('Stack:', error.stack);
    
    // Limpar token em caso de erro
    authAPI.logout();
    
    yield put(AuthActions.signInFailure(error));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Falha no login',
        message: error.message || 'Verifique seu e-mail/senha!',
      })
    );
  }
}

export function* signOut() {
  try {
    // Usar API REST ao invés de Firebase
    authAPI.logout();
    yield put(push('/signin'));
  } catch (error) {
    // yield put(SignlogoutFailure(error));
    console.log(error);
  }
}

// export function* syncFileUrl(storageRef, file, user) {
//   try {
//     const url = yield storageRef.getDownloadURL();

//     const userRef = yield api.firestore().collection('users').doc(user.id);

//     yield userRef.update({
//       avatarUrl: url,
//     });

//     yield put(AuthActions.closeFileModal());

//     yield put(
//       toastrActions.add({
//         type: 'success',
//         title: 'Avatar atualizado',
//         message: 'Seu avatar foi atualizado.',
//       })
//     );

//     yield put(AuthActions.uploadAvatarSuccess(url));
//   } catch (error) {
//     yield put(AuthActions.uploadAvatarFailure(error));
//     yield put(
//       toastrActions.add({
//         type: 'error',
//         title: 'Falha no upload',
//         message: 'Ops...Algo de errado aconteceu. Tente mais tarde.',
//       })
//     );
//   }
// }

// export function* uploadFile({ file }) {
//   const user = yield select((state) => state.auth.userActive);

//   const storageRef = yield api.storage().ref().child(`avatars/${uuidv1()}`);

//   const taskAvatar = storageRef.put(file);

//   taskAvatar.on('state_changed', (snapshot) => {
//     const pct = (snapshot.bytesTransferred * 100) / snapshot.totalBytes;
//     console.log(`${pct}%`);
//   });

//   // Wait for upload to complete
//   yield taskAvatar;

//   yield syncFileUrl(storageRef, file, user);
// }

export function* forgotPassword({ email }) {
  try {
    yield api.auth().sendPasswordResetEmail(email);

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'E-mail enviado!',
        message: 'Verifique seu e-mail para recuperar sua senha.',
      })
    );

    yield put(push('/signin'));

    yield put(AuthActions.forgotSuccess());
  } catch (error) {
    yield put(
      AuthActions.forgotFailure({ message: 'Error sent email password reset' })
    );

    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Falha no reset de senha',
        message: 'Ops...Algo de errado aconteceu. Tente mais tarde.',
      })
    );
  }
}

// export function* profileUpdate({ user }) {
//   try {
//     const userRef = yield api.firestore().collection('users').doc(user.id);

//     yield userRef.update({
//       name: user.fullName,
//       phone: user.phone,
//       state: user.state,
//       country: user.country,
//       updated_at: new Date(),
//     });

//     let userActive;
//     yield userRef.get().then((doc) => {
//       userActive = doc.data();
//     });

//     yield put(AuthActions.profileSuccess(userActive));
//   } catch (e) {
//     yield put(
//       toastrActions.add({
//         type: 'error',
//         title: 'Falha na atualização',
//         message: 'Ops...Algo de errado aconteceu. Tente mais tarde.',
//       })
//     );
//     yield put(
//       AuthActions.profileFailure({
//         message: 'Error update profile user',
//         e,
//       })
//     );
//   }
// }
